export default {"src":"/_next/static/media/java-logo.811545ce.svg","height":58,"width":43,"blurWidth":0,"blurHeight":0};